module.exports = __webpack_public_path__ + "img/underground_comm_fault_off.ff216d58.svg";